
(() => {
  function initInfiniteScroll() {
    const grid = document.querySelector("#product-grid");
    const pagination = document.querySelector(".pagination-wrapper");

    if (!grid || !pagination || grid.dataset.infiniteScroll === "true") {
      return;
    }

    const getNextLink = (container) =>
      container.querySelector("a.pagination__item--prev[href]");

    const firstNextLink = getNextLink(pagination);

    if (!firstNextLink) {
      console.warn("Scroll infinito: no se encontró el enlace siguiente.");
      return;
    }

    let nextUrl = firstNextLink.href;
    let loading = false;
    let finished = false;

    grid.dataset.infiniteScroll = "true";

    const sentinel = document.createElement("div");
    sentinel.setAttribute("aria-hidden", "true");
    sentinel.style.height = "1px";
    sentinel.style.width = "100%";
    grid.insertAdjacentElement("afterend", sentinel);

    console.info("Scroll infinito: inicializado.", {
      siguientePagina: nextUrl,
      productosIniciales: grid.querySelectorAll(":scope > li.grid__item").length
    });

    async function loadNextPage() {
      if (loading || finished || !nextUrl) return;

      loading = true;
      console.info("Scroll infinito: cargando", nextUrl);

      try {
        const response = await fetch(nextUrl, {
          credentials: "same-origin"
        });

        if (!response.ok) {
          throw new Error(`Error HTTP ${response.status}`);
        }

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newGrid = doc.querySelector("#product-grid");
        const newPagination = doc.querySelector(".pagination-wrapper");

        if (!newGrid) {
          throw new Error("No se encontró #product-grid en la página siguiente.");
        }

        const products = Array.from(newGrid.children).filter(
          (element) => element.matches("li.grid__item")
        );

        if (!products.length) {
          throw new Error("La página siguiente no contiene productos.");
        }

        const fragment = document.createDocumentFragment();

        products.forEach((product) => {
          fragment.appendChild(product.cloneNode(true));
        });

        grid.appendChild(fragment);

        const nextLink = newPagination
          ? getNextLink(newPagination)
          : null;

        if (nextLink && nextLink.href !== nextUrl) {
          nextUrl = nextLink.href;
          pagination.hidden = true;

          console.info("Scroll infinito: productos agregados.", {
            cantidad: products.length,
            siguientePagina: nextUrl,
            totalProductos: grid.querySelectorAll(
              ":scope > li.grid__item"
            ).length
          });
        } else {
          finished = true;
          observer.disconnect();
          window.removeEventListener("scroll", checkPosition);
          window.removeEventListener("resize", checkPosition);
          sentinel.remove();
          pagination.remove();

          console.info("Scroll infinito: se llegó al final de la colección.");
          return;
        }

        // Si todavía estamos cerca del final, cargar la siguiente página.
        requestAnimationFrame(checkPosition);

      } catch (error) {
        console.error("Scroll infinito: error al cargar productos.", error);

        pagination.hidden = false;
        grid.dataset.infiniteScroll = "false";
        observer.disconnect();
        window.removeEventListener("scroll", checkPosition);
        window.removeEventListener("resize", checkPosition);
        sentinel.remove();
        finished = true;

      } finally {
        loading = false;
      }
    }

    function checkPosition() {
      if (finished || loading) return;

      const position = sentinel.getBoundingClientRect();

      if (position.top <= window.innerHeight + 500) {
        loadNextPage();
      }
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          loadNextPage();
        }
      },
      { rootMargin: "500px 0px" }
    );

    observer.observe(sentinel);

    // Alternativa de detección mediante desplazamiento.
    window.addEventListener("scroll", checkPosition, { passive: true });
    window.addEventListener("resize", checkPosition);

    // Comprueba si ya estamos cerca del final al iniciar.
    checkPosition();
  }

  function start() {
    if (!("IntersectionObserver" in window)) {
      console.warn("Scroll infinito: IntersectionObserver no disponible.");
      return;
    }

    initInfiniteScroll();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
